import { NgModule, LOCALE_ID, ErrorHandler } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import localeNl from '@angular/common/locales/nl';

import { ServicesModule } from '../../../services/src/lib/services.module';
import { ComponentsModule } from '../../../components/src/lib/components.module';

import { AppRoutingModule } from './schadecoach.app-routing.module';
import { ErrorschermComponent } from './stappen/error/errorscherm.component';
import { VerzekeringkiezerComponent } from './stappen/verzekeringkiezer/verzekeringkiezer.component';
import { AppComponent } from './schadecoach.app.component';
import { ComponentsErrorHandler } from '@components/public_api';
import { CrosscuttingModule } from '@crosscutting/public_api';

registerLocaleData(localeNl);

const kanaal = 'SC';

@NgModule({
  imports: [
    CommonModule,
    AppRoutingModule,
    BrowserModule,
    ComponentsModule.forRoot(),
    ServicesModule.forRoot(),
    CrosscuttingModule.forRoot()
  ],
  declarations: [
    AppComponent,
    VerzekeringkiezerComponent,
    ErrorschermComponent
  ],
  bootstrap: [
    AppComponent
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: ComponentsErrorHandler,
    },
    { provide: LOCALE_ID, useValue: 'nl-NL' },
    { provide: 'KANAAL', useValue: kanaal }
  ]
})
export class AppModule { }
